<modal-sidebar
	class="evaluation"
	[visible]="isOpen"
	(closeModal)="emClosedSidebar.emit()"
>
	<div
		*ngIf="!isLoading && !hasError"
		header
		class="zk-flex zk-flex-col zk-gap-2"
	>
		<div class="evaluation__header">
			<span class="evaluation__title">{{ evaluationDetail.title }}</span>
			<div class="zk-flex zk-gap-3 zk-items-center">
				<span class="freud-icon-calendar-event freud-icon"> </span>
				<span class="evaluation__date">{{
					formatedDate(evaluationDetail.answeredAt)
				}}</span>
			</div>
		</div>
		<div class="instruments" *ngIf="evaluationDetail.instruments.length > 0">
			<div
				class="instrument"
				*ngFor="let instrument of evaluationDetail.instruments"
			>
				<span>{{ instrument.title }}</span>
				<div
					freud-tooltip
					[tooltipLabel]="instrument.tag.tooltip"
					class="tag"
					[ngStyle]="{ 'background-color': instrument.tag.color }"
				>
					{{ instrument.tag.text }}
				</div>
			</div>
		</div>
	</div>
	<div body class="evaluation__body">
		<div *ngIf="!isLoading && !hasError">
			<div class="questions">
				<ul class="zk-gap-2 zk-mb-3 zk-px-3">
					<li
						class="question__list-item"
						*ngFor="let question of evaluationDetail.tabs[0].questions"
					>
						<span class="question__title">{{ question.title }}</span>
						<span class="question__answer">{{ question.answer }}</span>
					</li>
				</ul>
			</div>
		</div>
		<div
			*ngIf="isLoading"
			class="zk-flex zk-h-full zk-items-center zk-justify-center"
		>
			<freud-loader></freud-loader>
		</div>
		<div
			*ngIf="!isLoading && hasError"
			class="zk-flex zk-h-full zk-items-center zk-justify-center"
		>
			<span>{{ 'EVALUATIONS.EVALUATION_BY_ID_ERRROR' | translate }} </span>
		</div>
	</div>
</modal-sidebar>
